export enum AlertCustomSerasaEnum {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  WARN = "WARN"
}
